<template>
  <div class="info-container">
    <div class="content" v-if="itemList.length > 0 || scrollFlag">
      <Item
        v-for="v in itemList"
        :key="v.id"
        :every="v"
        :curcer="v.articleId"
        @itemClick="goDetail(v)"
      ></Item>
      <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
    </div>
    <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData>
  </div>
</template>

<script>
import Item from "@/components/pager/Item";
import mixin from "@/mixins/esIndex";
import Scroll from "@/components/paging/scroll";
import NoData from "@/views/PCView/search/components/NoData.vue";
export default {
  components: {
    Item,
    Scroll,
    NoData,
  },
  mixins: [mixin],
  data() {
    return {
      itemList: [],
      params: {
        articleType: 8,
        paramStr: this.$route.query.paramStr,
        searchType:this.$route.query.searchType,
      },
    };
  },
  created() {
    // 论文列表
    this.getSearchList(this.params);
  },
  methods: {
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/meetingDetails",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
